import { useEffect, useState } from "react";
import { getConfigActive } from "./adminservice";

/**
 * Valeur officielle du Tip en F CFA (décision D1), lue sur la configuration
 * active d'admin-service — seule source. null tant qu'elle n'est pas lue ou
 * si elle est illisible : l'appelant n'affiche alors aucun montant en F CFA
 * plutôt qu'un montant faux. Jamais de valeur en dur.
 */
export function useValeurTip(): number | null {
  const [valeur, setValeur] = useState<number | null>(null);
  useEffect(() => {
    let vivant = true;
    getConfigActive().then((c: any) => {
      if (vivant && typeof c?.tipValueCfa === "number" && c.tipValueCfa > 0) setValeur(c.tipValueCfa);
    });
    return () => { vivant = false; };
  }, []);
  return valeur;
}

/** Montant en F CFA d'un nombre de Tips, ou null si la valeur du Tip est inconnue. */
export function enCfa(tips: number, valeurTip: number | null): number | null {
  return valeurTip == null || !Number.isFinite(tips) ? null : Math.round(tips * valeurTip);
}
